import UtpAdsRepository from '@/domain/repositories/UtpAdsRepository';
import UtpAdsDataStore from '../datastores/UtpAdsDataStore';
import UtpAdsDataStoreFactory from '../factories/UtpAdsDataStoreFactory';

export default class UtpAdsDataRepository implements UtpAdsRepository {
  getUtpAdsData() {
    const authDataStore: UtpAdsDataStore = UtpAdsDataStoreFactory.create();
    return authDataStore.getUtpAdsData();
  }
}
